import { render, staticRenderFns } from "./StudentCohort.vue?vue&type=template&id=073ab51a"
import script from "./StudentCohort.vue?vue&type=script&lang=js"
export * from "./StudentCohort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports